export default __webpack_public_path__ + "static/media/icon-cocktail-white.1f0e3bf8.svg";